export default __webpack_public_path__ + "static/media/p-plus-2.97c73932.svg";